import React from 'react';
import withStyles from '@mui/styles/withStyles';
import Close from '@mui/icons-material/Close';

const styles = theme => ({
    // Laid out as a column so the image can take the space the close button
    // does not, and centre itself in it.
    modal: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        zIndex: 999,
        boxSizing: 'border-box',
        flexDirection: 'column',
        padding: 20,
        paddingTop: 56,
    },
    image: {
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain',
    },
    closeButton: {
        position: 'absolute',
        top: 8,
        right: 8,
        // Padded out to a thumb-sized target rather than the glyph's own 24px.
        padding: 10,
        boxSizing: 'content-box',
        cursor: 'pointer',
        color: 'white',
        fontSize: '24px',
        zIndex: 1,
    },
    imageContainer: {
        flex: 1,
        minHeight: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }
});

const ImagePreviewModal = ({ classes, visible, imageUrl, onClose }) => {
    const displayModal = visible ? { display: 'flex' } : { display: 'none' };
    return (
      <div
        className={classes.modal}
        style={displayModal}
        onClick={onClose}
      >
        <Close
            className={classes.closeButton}
            onClick={onClose}
        />
        <div className={classes.imageContainer}>
            <img src={imageUrl} className={classes.image} alt="Preview"  onClick={(e) => e.stopPropagation()} />
        </div>
      </div>
    );
};

export default withStyles(styles)(ImagePreviewModal);
